export default "__VITE_ASSET__DbXD2RvA__"